/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Review_Feedback_TitleInputs */

const en_mobile_review_feedback_title = /** @type {(inputs: Mobile_Review_Feedback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How can we make Listening better?`)
};

const es_mobile_review_feedback_title = /** @type {(inputs: Mobile_Review_Feedback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo podemos mejorar Listening?`)
};

/**
* | output |
* | --- |
* | "How can we make Listening better?" |
*
* @param {Mobile_Review_Feedback_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_review_feedback_title = /** @type {((inputs?: Mobile_Review_Feedback_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Review_Feedback_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_review_feedback_title(inputs)
	return en_mobile_review_feedback_title(inputs)
});